import { prop } from '@lib/style/theme';
import { cleanProps } from '@lib/utils';
import { css } from 'styled-components';
import { unitStrict } from '../unit';

export interface MarginProps {
    m?: number | string;
    margin?: number | string;
}

export const margin = (defaultValue?: MarginProps['margin']): any => css`
    & {
        margin: ${prop(['m', 'margin'], defaultValue, unitStrict)};
    }
`;

margin.clean = (props): any => cleanProps(props, ['m', 'margin']);
